/** @jsxImportSource @emotion/react */
import React from "react";
import { APP_NAME, APP_VERSION } from "configs/AppConfig";
import { css } from "@emotion/react";
import {
  TEMPLATE,
  MEDIA_QUERIES,
  DARK_MODE,
  BORDER,
} from "constants/ThemeConstant";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function Footer(props) {
  const currentTheme = useSelector((state) => state.theme.currentTheme);

  return (
    <footer
      className={props.className}
      css={css`
        height: ${TEMPLATE.FOOTER_HEIGHT}px;
        display: flex;
        margin: 0 ${TEMPLATE.LAYOUT_CONTENT_GUTTER}px;
        align-items: center;
        justify-content: space-between;

        @media ${MEDIA_QUERIES.MOBILE} {
          justify-content: center;
          flex-direction: column;
        }
      `}
    >
      <span>
        Copyright &copy; {`${new Date().getFullYear()}`}{" "}
        <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights
        reserved.
      </span>

      <span>🚀 Versi {APP_VERSION}</span>
    </footer>
  );
}
